export default class Inserat{
    constructor(){
        this.id = 0;
        this.fotos = [];
        this.video = '';
        this.videoType = '';
        this.contact = {};
        this.impressum = {};
    }

    setId(val){
        this.id = val;
    }
    getId(){
        return this.id;
    }

    setCategoryId(val){
        this.category_id = val;
    }
    getCategoryId(){
        return this.category_id;
    }

    setDescription(val){
        this.description = val;
    }
    getDescription(){
        return this.description;
    }

    setRentalConditions(val){
        this.rental_conditions = val;
    }
    getRentalConditions(){
        return this.rental_conditions;
    }

    setName(val){
        this.name = val;
    }
    getName(){
        return this.name;
    }

    setPriceAmount(val){
        this.price_amount = val;
    }
    getPriceAmount(){
        if(this.price_amount)
            return this.price_amount;
        else if(this.price_info)
            return this.price_info;
    }

    setPriceInfo(val){
        this.price_info = val;
    }
    getPriceInfo(){
        return this.price_info;
    }

    setPriceBase(val){
        this.price_base = val;
    }
    getPriceBase(){
        return this.price_base;
    }

    setPlz(val){
        this.plz = val;
    }
    getPlz(){
        return this.plz;
    }

    setOrt(val){
        this.ort = val;
    }
    getOrt(){
        return this.ort;
    }

    setGeoId(val){
        this.district_id = val;
    }
    getGeoId(){
        return this.district_id;
    }

    setGeoRadius(val){
        this.geo_radius = val;
    }
    getGeoRadius(){
        return this.geo_radius;
    }

    setDelivery(val){
        //if(val == '') val = 'keine_angabe';
        this.delivery = val;
    }
    getDelivery(){
        return this.delivery;
    }

    setContact(val){
        this.contact.title = val.title;
        this.contact.company = val.company;
        this.contact.firstname = val.firstname;
        this.contact.lastname = val.lastname;
        this.contact.phone = val.phone;
        this.contact.email = val.email;
    }
    getContact(){
        return this.contact;
    }

    setImpressum(val){
        this.impressum.company_name     = val.company_name;
        this.impressum.company_address  = val.company_address;
        this.impressum.company_phone    = val.company_phone;
        this.impressum.company_fax      = val.company_fax;
        this.impressum.company_email    = val.company_email;
        this.impressum.company_homepage = val.company_homepage;
        this.impressum.post_code        = val.post_code;
        this.impressum.city             = val.city;
        this.impressum.status           = val.status;

        this.impressum.trade_register_presentation  = val.trade_register_presentation;
        this.impressum.trade_register_number        = val.trade_register_number;
        this.impressum.tax_number                   = val.tax_number;
        this.impressum.tax_exchange_number          = val.tax_exchange_number;
        this.impressum.trade_register_court         = val.trade_register_court;
    }
    getImpressum(){
        return this.impressum;
    }

    setFotos(val){
        this.fotos.push(val);
    }
    getFotos(){
        return this.fotos;
    }

    setVideo(val){
        this.video = val;
    }
    getVideo(){
        return this.video;
    }

    setVideoType(val){
        this.videoType = val;
    }
    getVideoType(){
        return this.videoType;
    }

    isPriceTabAllowed() {
        return this.price_amount > 0 || this.price_info != undefined ? true : false;
    }

    getLocation() {
        return (this.ort && this.plz && this.geo_radius);
    }

    setExtraPlz(val) {
        this.extra_plz = val;
    }
    getExtraPlz() {
        return this.extra_plz;
    }





    static getObjectFromJSON(inseratJson){
        let inserat               = new Inserat;

        inserat.id                = inseratJson.id
        inserat.category_id       = inseratJson.category_id
        inserat.name              = inseratJson.name
        inserat.description       = inseratJson.description
        inserat.rental_conditions = inseratJson.rental_conditions
        inserat.price_amount      = inseratJson.price_amount
        inserat.price_info        = inseratJson.price_info
        inserat.price_base        = inseratJson.price_base
        inserat.plz               = inseratJson.plz
        inserat.ort               = inseratJson.ort
        inserat.district_id       = inseratJson.district_id
        inserat.geo_radius        = inseratJson.geo_radius
        inserat.delivery          = inseratJson.delivery
        inserat.contact           = inseratJson.contact
        inserat.fotos             = inseratJson.fotos
        inserat.video             = inseratJson.video
        inserat.videoType         = inseratJson.videoType
        inserat.extra_plz         = inseratJson.extra_plz
        inserat.impressum         = inseratJson.impressum


        return inserat;
    }
}
